"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CbaDogRadio = exports.CbaCatRadio = exports.CbaAnimalRadioInputs = exports.CbaAboutPet = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultAboutPet = require("../../../defaults/quoteTools/defaultAboutPet");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CbaDogRadio = exports.CbaDogRadio = {
  label: 'Dog',
  value: 'Dog'
};
var CbaCatRadio = exports.CbaCatRadio = {
  label: 'Cat',
  value: 'Cat'
};
var CbaAnimalRadioInputs = exports.CbaAnimalRadioInputs = [_objectSpread({}, CbaDogRadio), _objectSpread({}, CbaCatRadio)];
var CbaAboutPet = exports.CbaAboutPet = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet), {}, {
  heading: function heading(_ref) {
    var petName = _ref.petName;
    return "".concat(petName || 'Your pet');
  },
  accordionBehaviour: true,
  petSpeciesRadios: {
    groupLabel: function groupLabel() {
      return 'I have a...';
    },
    groupLabelTooltip: null,
    radioInputs: CbaAnimalRadioInputs
  },
  petNameInput: _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet.petNameInput), {}, {
    placeholder: null
  }),
  petBreedInput: _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet.petBreedInput), {}, {
    label: function label(petName) {
      return "".concat(petName || 'My pet', "'s breed is...");
    },
    placeholder: 'Start typing breed',
    validation: {
      required: 'Please enter your pet\'s breed.'
    }
  }),
  petBirthdate: _objectSpread({}, _defaultAboutPet.DefaultAboutPet.petBirthdate),
  petGenderRadios: {
    groupLabel: function groupLabel(petName) {
      return "".concat(petName || 'My pet', " is a...");
    },
    radioInputs: [{
      label: 'Male',
      value: 'Male'
    }, {
      label: 'Female',
      value: 'Female'
    }]
  },
  petDesexedRadios: {
    groupLabel: function groupLabel(petName) {
      return "".concat(petName || 'My pet', " is desexed...");
    },
    radioInputs: [{
      label: 'Yes',
      value: 1
    }, {
      label: 'No',
      value: 2
    }, {
      label: 'Unsure',
      value: 0
    }]
  }
});